// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","tablet":"(max-width: 1024px)","container":"container--szfd","content":"content-U1rLd","controls":"controls-3b4Ia"};